module.exports = __webpack_public_path__ + "static/media/UndIcon.93e04f03.svg";